var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "crm-reminder"
    }
  }, [_vm.activeReminder ? _c('aside', {
    staticClass: "crm-task-reminder"
  }, [_c('div', {
    staticClass: "crm-task-reminder__header"
  }, [_c('span', [_vm._v(_vm._s(_vm.reminderHeader))]), _c('button', {
    attrs: {
      "type": "button",
      "title": "Fechar"
    },
    on: {
      "click": _vm.dismissCurrent
    }
  }, [_c('i', {
    staticClass: "la la-times"
  })])]), _c('strong', [_vm._v(_vm._s(_vm.activeReminder.titulo))]), _c('p', [_vm._v(_vm._s(_vm.reminderContext))]), _c('div', {
    staticClass: "crm-task-reminder__time"
  }, [_c('i', {
    staticClass: "la la-clock"
  }), _vm._v(" " + _vm._s(_vm.formatDateTime(_vm.reminderDate)) + " ")]), _c('div', {
    staticClass: "crm-task-reminder__actions"
  }, [_c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openReminder
    }
  }, [_vm._v(" Abrir ")]), _vm.canComplete ? _c('button', {
    staticClass: "btn btn-light-success btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.completeTask
    }
  }, [_vm._v(" Concluir ")]) : _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.dismissCurrent
    }
  }, [_vm._v(" Fechar ")])]), _vm.canSnooze ? _c('div', {
    staticClass: "crm-task-reminder__snooze"
  }, [_c('b-form-input', {
    attrs: {
      "min": "1",
      "max": "1440",
      "type": "number"
    },
    model: {
      value: _vm.snoozeMinutes,
      callback: function callback($$v) {
        _vm.snoozeMinutes = _vm._n($$v);
      },
      expression: "snoozeMinutes"
    }
  }), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.snoozeTask
    }
  }, [_vm._v(" Lembrar depois ")])], 1) : _vm._e()]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };